export const environment = {
  production: true,
  logs: 'error',
  basePath: '/',
};
